var _style, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClaim(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 90 90",
    style: {
      enableBackground: "new 0 0 90 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;fill:#0A89E0;}\n\t.st2{display:inline;}\n\t.st3{fill:#0A89E0;}\n\t.st4{fill:#53ADF8;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.1,18C1,22.2,1,29.1,5.1,33.4l24.5,25.4l1.6,1.7l0,0c2,2.1,4.7,3.2,7.4,3.2s5.4-1.1,7.4-3.2l6.2-6.4 c1.4-1.4,1.4-3.7,0-5.1c-1.4-1.4-3.6-1.4-4.9,0l-6.2,6.4c-1.4,1.4-3.6,1.4-5,0l0,0L10,28.4c-1.4-1.4-1.4-3.7,0-5.1l12.4-12.8 c1.4-1.4,3.6-1.4,5,0L38.7,22c1.4,1.4,3.6,1.4,4.9,0c1.4-1.4,1.4-3.7,0-5.1L32.3,5.2C28.2,1,21.5,1,17.5,5.2L5.1,18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.4,69c-1.4,1.4-1.4,3.7,0,5.1l11.3,11.7c2,2.1,4.7,3.2,7.4,3.2s5.4-1.1,7.4-3.2L82.9,73 c4.1-4.2,4.1-11.1,0-15.4l-26.1-27c-4.1-4.2-10.8-4.2-14.8,0L35.8,37c-1.4,1.4-1.4,3.7,0,5.1c1.4,1.4,3.6,1.4,4.9,0l6.2-6.4 c1.4-1.4,3.6-1.4,5,0l26.1,27c1.4,1.4,1.4,3.7,0,5.1L65.6,80.7c-1.4,1.4-3.6,1.4-5,0L49.3,68.9C48,67.5,45.8,67.5,44.4,69z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.5,30.4c0-2.5,1.8-4.5,4-4.5s4,2,4,4.5v22.5c0,2.5-1.8,4.5-4,4.5H33.1c-2.2,0-4-2-4-4.5s1.8-4.5,4-4.5h10 L13.3,14.1c-1.5-1.8-1.5-4.5,0-6.3c0.8-0.9,1.8-1.4,2.9-1.4s2.1,0.5,2.9,1.4l29.4,33.9V30.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.2,38.1c2.2,0,4,2,4,4.5v9.3c0,10.7,1.7,17.6,5.4,21.9C18.3,78,24.3,80,33.5,80h24.2c9.2,0,15.1-2,18.8-6.2 c3.7-4.3,5.4-11.2,5.4-21.9v-9.4c0-0.4,0.1-0.8,0.2-1.2c-0.1-0.4-0.2-0.8-0.2-1.2c0-10.7-1.7-17.6-5.4-21.9 C72.8,14,66.9,12,57.7,12h-8.1c-2.2,0-4-2-4-4.5s1.8-4.5,4-4.5h8.1C69.2,3,77,5.8,82.3,11.9c5.2,6.1,7.7,15,7.7,28.2 c0,0.4-0.1,0.8-0.2,1.2c0.1,0.4,0.2,0.8,0.2,1.2v9.4c0,13.2-2.4,22.1-7.7,28.2C77,86.2,69.2,89,57.7,89H33.5 C22,89,14.2,86.2,8.9,80.1c-5.2-6.1-7.7-15-7.7-28.2v-9.3C1.2,40.1,3,38.1,5.2,38.1z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M45,41.5c-1.7,0-3.4-0.8-4.6-2.1L17.8,13.7c-1.7-1.9-1.5-4.8,0.3-6.5c1.9-1.7,4.7-1.6,6.4,0.3L45,30.8 L65.5,7.5c1.7-1.9,4.5-2.1,6.4-0.3c1.9,1.7,2,4.6,0.3,6.5L49.6,39.4C48.4,40.7,46.7,41.5,45,41.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M45,83.9c-1.7,0-3.4-0.8-4.6-2.1L17.8,56.1c-1.7-1.9-1.5-4.8,0.3-6.5c1.9-1.7,4.7-1.6,6.4,0.3L45,73.1 l20.5-23.3c1.7-1.9,4.5-2.1,6.4-0.3c1.9,1.7,2,4.6,0.3,6.5L49.6,81.7C48.4,83.1,46.7,83.9,45,83.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M45,62.7c-1.7,0-3.4-0.8-4.6-2.1L17.8,34.9c-1.7-1.9-1.5-4.8,0.3-6.5c1.9-1.7,4.7-1.6,6.4,0.3L45,52 l20.5-23.3c1.7-1.9,4.5-2.1,6.4-0.3c1.9,1.7,2,4.6,0.3,6.5L49.6,60.6C48.4,61.9,46.7,62.7,45,62.7z"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M78,25.8h-2v-1.9c0-5.5-4.5-10-10-10h-2V12c0-5.5-4.5-10-10-10H12C6.5,2,2,6.5,2,12v42c0,5.5,4.5,10,10,10h2 v1.9c0,5.5,4.5,10,10,10h2v1.9c0,5.5,4.5,10,10,10h42c5.5,0,10-4.5,10-10v-42C88,30.3,83.5,25.8,78,25.8z M34.1,35.9 c0-1.1,0.8-1.9,1.9-1.9h42c1.1,0,1.9,0.8,1.9,1.9v42c0,1.1-0.8,1.9-1.9,1.9H36c-1.1,0-1.9-0.8-1.9-1.9V35.9z M22.1,23.9 c0-1.1,0.8-1.9,1.9-1.9h42c1.1,0,1.9,0.8,1.9,1.9v1.9H36c-5.5,0-10,4.5-10,10v31.9h-2c-1.1,0-1.9-0.8-1.9-1.9V23.9z M24,13.8 c-5.5,0-10,4.5-10,10v31.9h-2c-1.1,0-1.9-0.8-1.9-1.9v-42c0-1.1,0.8-1.9,1.9-1.9h42c1.1,0,1.9,0.8,1.9,1.9v1.9H24V13.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M42,60.9h10.9v10.9c0,2.2,1.8,4,4,4s4-1.8,4-4V60.9H72c2.2,0,4-1.8,4-4s-1.8-4-4-4H61V41.8c0-2.2-1.8-4-4-4 s-4,1.8-4,4v10.9H42c-2.2,0-4,1.8-4,4C38,59.1,39.8,60.9,42,60.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaim);
export default __webpack_public_path__ + "static/media/Claim.c77f8c6af21ff9581d2a61f589319041.svg";
export { ForwardRef as ReactComponent };